import { useModal } from '@hooks/useModal'
import { NewUserForm } from '../components/NewUserForm'
import { useTranslation } from 'react-i18next'

export const useNewUser = () => {
  const modal = useModal()
  const { t } = useTranslation()

  const newUser = () => {
    const id = modal.form({
      title: t('features.usersAdmin.createANewUser'),
      content: (
        <NewUserForm
          onCancel={() => modal.close(id)}
          onSave={() => modal.close(id)}
        />
      ),
    })
  }

  return { newUser }
}
